import React from 'react';
import { Icon } from 'components';
import { Grid, Typography } from 'e100-react-components';
import { useCarEBoxDashboardDataByObuNumber, useEBoxLocationByObuNumber } from 'entities/cars';
import { useCarOperations } from 'entities/cars';
import { useMapContext } from 'entities/map';
import { useStyles } from './styles';

import { AutoIcon, CarLicense, TrailerAxles, LocationPosition } from './components';
import { EBoxDashboardData } from 'entities/cars/types';
import { DeviceBattery } from 'shared/components';
import { logAmplitudeEvent } from 'shared/utils/amplitude/amplitude';

interface ObuCarProps {
  obuNumber: string;
  onClick: (car: EBoxDashboardData) => void;
}

export const ObuCar = ({ obuNumber, onClick }: ObuCarProps) => {
  const { setCenter, setZoom } = useMapContext();
  const carEBoxDashboardData = useCarEBoxDashboardDataByObuNumber(obuNumber);
  const eBoxLocation = useEBoxLocationByObuNumber(obuNumber);
  const { autoNumber, latitude, longitude } = eBoxLocation || {};
  const { setSelectedCarEBoxLocation } = useCarOperations();

  const { currentVehicle, batteryStatus, trailerAxles } = carEBoxDashboardData || {};
  const { value: trailerAxlesValue } = trailerAxles || { value: 0 };
  const {
    axleCount = 0,
    licensePlate,
    weights: { vehicleWeightUnladen } = {},
  } = currentVehicle || {};

  const axles = axleCount + Number(trailerAxlesValue);

  const classes = useStyles();
  return (
    <button
      className={classes.button}
      onClick={() => {
        if (carEBoxDashboardData) {
          onClick(carEBoxDashboardData);
        }

        if (eBoxLocation) {
          setSelectedCarEBoxLocation(eBoxLocation);
        }

        setCenter({ lat: latitude, lng: longitude });
        setZoom(12);

        logAmplitudeEvent('clickEboxCar', {
          extra: {
            licensePlate,
          },
        });
      }}
    >
      <Grid
        container
        classes={{
          root: classes.contentRoot,
        }}
        spacing={0}
      >
        <Grid item>
          <AutoIcon autoNumber={autoNumber} vehicleWeightUnladen={vehicleWeightUnladen} />
        </Grid>
        <Grid item classes={{ root: classes.itemText }}>
          <Grid container direction="column" spacing={0}>
            <Grid item classes={{ root: classes.itemPadding }}>
              <CarLicense autoNumber={autoNumber} />
            </Grid>
            <Grid item classes={{ root: classes.itemPadding }}>
              <Typography
                variant="subtitle2"
                color="textSecondary"
              >
                {obuNumber}
              </Typography>
            </Grid>
            <Grid item classes={{ root: classes.itemPadding }}>
              <LocationPosition latitude={latitude} longitude={longitude} />
            </Grid>
            {
              carEBoxDashboardData && (
                <Grid item>
                  <Grid container>
                    <Grid item>
                      <DeviceBattery batteryCharge={Number((batteryStatus || {value: 0}).value)} />
                    </Grid>
                    <Grid item>
                      <TrailerAxles axles={axles} />
                    </Grid>
                  </Grid>
                </Grid>
              )
            }
          </Grid>
        </Grid>
        {
          carEBoxDashboardData && (
            <Grid item>
              <Icon kind="next"></Icon>
            </Grid>
          )
        }
      </Grid>
    </button>
  );
};
